package com.yogaaicoach.user

import com.yogaaicoach.pages.auth.TokenData


// TODO maybe this class is not needed anymore, can use TokenDataManager
data class UserInfo (
    val uid: String,
    val tokenData: TokenData
)